define('views/savings/manage',[
    'views/_base/baseview',
    'text!views/savings/manage.html',
    'views/savings/savings_account',
    'views/shared/button/button',
    'models/causes/allocation'
], function(BaseView, Template, SavingAccount, ButtonComponent, AllocationModel){
    'use strict';

    return BaseView.extend({
        id      : 'savings-manage-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
            'keyup .js-account-allocation-percentage-input': 'adjustAllocationsMODAL',
            'blur .js-account-allocation-percentage-input' : 'adjustAllocationsBlurMODAL',
            'focus .js-account-allocation-percentage-input': 'adjustAllocationsFocusMODAL',

            'click .js-add-allocation'             : 'addAllocationsMODAL',
            'click #pf-modal-close-btn'            : 'closeMODAL',
            'click .js-deduct-allocation'          : 'deductAllocationsMODAL',
            'click .js-savings-manage-save-btn'    : 'saveAllocationsMODAL',
            'click .js-savings-manage-cancel-btn'  : 'closeMODAL',
            'click .js-allocations-toggle-checkbox': 'toggleAllocationMODAL'
        },
        initialize: function(options){
            options = options || {};

            this.savings = options.savings;
            this.spending_account = null;
            this.allocations_status = null;
            this.allow_edits = true;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            setTimeout(function(){
                that.checkAllocationStatus();

                that.addApplyButton();
            },300);

            return this;
        },

        loadData: function(){
            var that = this;

            pf.accounts.getAllocations(function(allocations){

                if(allocations.length){

                    allocations.forEach(function(account){
                        var data = { account: account };

                        if(account.ATID == enums.accountTypeEnum.GeneralFund){
                            data.className = 'pf-account';
                        }

                        account = new SavingAccount(data);

                        $('#savings-manage-accounts').append(account.el);
                    });

                } else {

                    that.$el.find('.js-savings-manage-save-btn').hide();
                    that.$el.find('.js-savings-manage-cancel-btn').hide();

                    that.$el.find('.js-savings-manage-empty-state').show();

                }

            });
            
        },

        addApplyButton: function(){

            this.save_allocations_button = new ButtonComponent({
                // General
                elementName        : '.js-savings-manage-buttons-container',
                calling_view       : this,
                // Transactional
                is_transaction     : false,
                // Default
                btn_label          : 'Apply',
                btn_callback       : this.saveAllocationsMODAL,
                btn_retry_callback : this.saveAllocationsMODAL,
                // Confirm
                btn_confirm        : false,
                // Cancel
                btn_cancel         : true,
                btn_cancel_label   : 'Cancel',
                btn_cancel_callback: this.cancelSaveAllocationsMODAL,
                // Success
                btn_success        : true,
                btn_success_delay  : 700,
                btn_success_label  : 'OK',
                btn_success_message: 'Allocations successfully updated',
                btn_success_callback: this.allocationsSaveSuccessMODAL,
                // Error
                btn_error          : true,
                btn_error_delay    : 700,
                btn_error_label    : 'Retry',
                btn_error_cancel_label: 'Cancel',
                btn_error_message  : 'Allocations could not be updated',
                btn_error_callback : this.canceledOnError
            });

        },

        saveAllocationsMODAL: function(processComplete, that){
            var that = (that) ? that : this;

            that.allow_edits = false;

            pf.accounts.saveAllocations(function(response){
                var success_boolean = false;

                if(response){

                    success_boolean = true;
                    
                }

                if(processComplete.name){
                    that.save_allocations_button[processComplete.name](success_boolean);                       
                } else {
                    processComplete(success_boolean, that.save_allocations_button);
                }

                that.allow_edits = true;
                
            });
        },

        allocationsSaveSuccessMODAL: function(resetButtons, that){
            var that = (that) ? that : this;

            that.closeMODAL();
            // TODO: Whether user is on savings or a saving, reload the data without refreshing page
            window.location.reload();
        },

        cancelSaveAllocationsMODAL: function(that){
            var that = (that) ? that : this;
            
            that.closeMODAL();
        },

        canceledOnError: function(that){},

        checkAllocationStatus: function(){
            var that = this;

            $.ajax({
                type       : 'GET',
                async      : false,
                url        : pf.accountsURL + '/Allocation/Enabled/',
                contentType: 'application/json',
                success    : function(response, val){
                    that.allocations_status = response.allocationEnabled;
                    that.updateStatusMODAL();
                    that.changeAllocationStatus();
                },
                error      : function(response, val){
                    // TODO: Handle this error
                }
            });

        },

        updateStatusMODAL: function(){

            if(this.allocations_status){
                
                // Update the toggle button to defualt state
                $('.js-allocations-toggle-checkbox').prop('checked', false);

            } else {

                // Update the toggle button to show as "paused"
                $('.js-allocations-toggle-checkbox').prop('checked', true);
                
            }

        },

        updateAllocationStatusMODAL: function(status){
            var that = this;

            if(this.allow_edits){

                $.ajax({
                    type       : 'PUT',
                    url        : pf.accountsURL + '/Allocation/' + status,
                    contentType: 'application/json',
                    success    : function(response, value){
                        that.allocations_status = status;
                        that.changeAllocationStatus();
                    },
                    error      : function(response, value){
                        
                        that.changeAllocationStatus();

                        if (response.status == 400){
                            jAlert("There was an error updating your allocation setting. Please try again.");
                        }

                    }
                });

            }

        },

        toggleAllocationMODAL: function(e){
            var status = ($(e.currentTarget).is(':checked')) ? false : true;

            this.calling_view.updateAllocationStatusMODAL(status);
        },

        changeAllocationStatus: function(){

            if(this.allocations_status){
                
                // Re-add correct PF account percentage and show all savings
                $('.js-spending-account-allocation-percentage').html(pf.accounts.spending_account.allocation_percentage + '%');
                $('#savings-manage-accounts').find('li').show();

                // Show buttons
                $('.js-savings-manage-save-btn').show();
                $('.js-savings-manage-cancel-btn').show();

            } else {
                
                // Modify the savings list to only show the PF Account at 100%
                $('#savings-manage-accounts').find('li').hide();
                $('.js-spending-account-allocation-percentage').html('100%');
                $('#savings-manage-accounts').find('li.pf-account').show();

                // Hide buttons
                $('.js-savings-manage-save-btn').hide();
                $('.js-savings-manage-cancel-btn').hide();

            }

        },

        adjustAllocationsFocusMODAL: function(e){
            
            if(!this.calling_view.allow_edits){
                return false;
            }

            var input = $(e.currentTarget);

            input.attr('placeholder','');
        },

        adjustAllocationsBlurMODAL: function(e){
            
            if(!this.calling_view.allow_edits){
                return false;
            }

            var input = $(e.currentTarget),
                account_id = input.data().accountid,
                original_percentage = pf.accounts.getAllocation(account_id);

            this.adjustAllocationsMODAL(e);

            if(input.val() == ''){
                input.attr('placeholder',original_percentage);
                input.val(original_percentage);
            } else {
                input.attr('placeholder',input.val());
            }

        },

        adjustAllocationsMODAL: function(e){

            if(!this.calling_view.allow_edits){
                return false;
            }

            var input = $(e.currentTarget),
                account_id = input.data().accountid,
                allocation = input.parent().parent().find('.js-account-allocation-percentage').find('.js-account-allocation-percentage-input'),
                percentage = parseFloat(allocation.val()),
                original_percentage = pf.accounts.getAllocation(account_id);

            // Protect against non-numbers and negative integers
            if(_.isNumber(percentage) && percentage >= 0 && percentage <= 100){

                var difference = Math.abs(original_percentage - percentage),
                    is_adding = (original_percentage < percentage) ? true : false,
                    sa_allocation = $('.js-spending-account-allocation-percentage'),
                    sa_percentage = parseFloat(sa_allocation.html());
                
                if(is_adding && (sa_percentage - difference) < 0 || !is_adding && (sa_percentage + difference) > 100){
                    // console.log('Rules are being violated',sa_percentage - difference,sa_percentage + difference);
                    return false;
                }

                if(percentage >= 0 && percentage <= 100 && sa_percentage > 0){

                    if(is_adding){

                        sa_percentage = sa_percentage - difference;
                        pf.accounts.storeAllocation(account_id,percentage);
                        sa_allocation.html(sa_percentage + '%');
                        pf.accounts.storeAllocation(pf.accounts.spending_account.account_id, sa_percentage);
                    
                    } else {
                        
                        sa_percentage = sa_percentage + difference;
                        pf.accounts.storeAllocation(account_id,percentage);
                        sa_allocation.html(sa_percentage + '%');
                        pf.accounts.storeAllocation(pf.accounts.spending_account.account_id,sa_percentage);

                    }
                    
                }

            } else if(percentage > 100 || percentage < 0){
                $(e.currentTarget).val(original_percentage);
            } else if(input.val() == ''){
                // DO Nothing
            } else {
                $(e.currentTarget).val(original_percentage);
            }
            
        },

        deductAllocationsMODAL: function(e){

            if(!this.calling_view.allow_edits){
                return false;
            }

            var button = $(e.currentTarget),
                account_id = button.data().accountid,
                allocation = button.parent().find('.js-account-allocation-percentage').find('.js-account-allocation-percentage-input'),
                percentage = parseFloat(allocation.val()),
                sa_allocation = $('.js-spending-account-allocation-percentage'),
                sa_percentage = parseFloat(sa_allocation.html());
            
            if(percentage > 0){
                percentage = percentage - 5;
                allocation.val(percentage);
                pf.accounts.storeAllocation(account_id,percentage);

                sa_percentage = sa_percentage + 5;
                sa_allocation.html(sa_percentage + '%');
                pf.accounts.storeAllocation(pf.accounts.spending_account.account_id,sa_percentage);
            }

        },

        addAllocationsMODAL: function(e){

            if(!this.calling_view.allow_edits){
                console.log('addAllocationsMODAL yess',this);
                return false;
            }

            var button = $(e.currentTarget),
                account_id = button.data().accountid,
                allocation = button.parent().find('.js-account-allocation-percentage').find('.js-account-allocation-percentage-input'),
                percentage = parseFloat(allocation.val()),
                sa_allocation = $('.js-spending-account-allocation-percentage'),
                sa_percentage = parseFloat(sa_allocation.html());
            
            if(percentage < 100 && sa_percentage > 0){
                percentage = percentage + 5;
                allocation.val(percentage);
                pf.accounts.storeAllocation(account_id,percentage);

                sa_percentage = sa_percentage - 5;
                sa_allocation.html(sa_percentage + '%');
                pf.accounts.storeAllocation(pf.accounts.spending_account.account_id,sa_percentage);
            }
            
        },

        closeMODAL: function(){
            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });
        },

        close: function(){}
    });
});

